// Properties holding codes used only to find the payer (QR, barcode), not shown to the staff
// TODO: Mark it somehow different
export const isScanProperty = (property) => {
  const name = property.name.toLowerCase();
  return name.includes('qr')
    || name.includes('kod')
    || name.includes('barcode');
};

export default isScanProperty;
